import { render, staticRenderFns } from "./PlanTab.vue?vue&type=template&id=d047c864&scoped=true"
import script from "./PlanTab.vue?vue&type=script&lang=ts"
export * from "./PlanTab.vue?vue&type=script&lang=ts"
import style0 from "./PlanTab.vue?vue&type=style&index=0&id=d047c864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d047c864",
  null
  
)

export default component.exports